import "./public.22ef4b5f.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire707f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire707f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
// --- START OF FILE public/landingpage/js/index-landing.js ---
/**
 * index-landing.js v1.1 - Parcel Entry Point
 * Punto di ingresso principale per gli script della landing page,
 * gestito da Parcel. Assicura il corretto ordine di caricamento dei moduli.
 */ parcelRequire("fIGEf");
parcelRequire("bausZ");
parcelRequire("gATpx");
parcelRequire("giRuH");
parcelRequire("6T81k");
parcelRequire("kMQyD");
parcelRequire("3New7");
// --- START OF FILE public/landingpage/js/auth-ui.js ---
/**
 * landingpage/js/auth-ui.js v1.2 - Calls Global UI Update
 * Gestione UI Modali Auth (Login/Register/Reset) sulla landing page.
 * MODIFICATO: Chiama window.updateGlobalUserUI definita in landingpage/js/main.js
 *             per aggiornare l'UI dell'header in modo centralizzato.
 * MANTIENE: Logica gestione modali e interazione con AuthManager.
 */ window.LandingPageAuthUI = function() {
    let loginModal, registerModal, resetModal, loginForm, registerForm, resetForm;
    let loginError, registerError, resetError, resetSuccess, loading;
    function initialize() {
        console.log("[AuthUI Landing] Initialize (v1.2 - Calls Global UI Update)...");
        loginModal = document.getElementById('login-modal');
        registerModal = document.getElementById('register-modal');
        resetModal = document.getElementById('reset-modal');
        loginForm = document.getElementById('login-form');
        registerForm = document.getElementById('register-form');
        resetForm = document.getElementById('reset-form');
        loginError = document.getElementById('login-error');
        registerError = document.getElementById('register-error');
        resetError = document.getElementById('reset-error');
        resetSuccess = document.getElementById('reset-success');
        loading = document.getElementById('loading');
        document.removeEventListener('firebase-auth', handleAuthEvent);
        document.addEventListener('firebase-auth', handleAuthEvent);
        setupLandingPageEventListeners();
        if (typeof window.updateGlobalUserUI === 'function') {
            console.log("[AuthUI Landing] Chiamo window.updateGlobalUserUI per stato iniziale.");
            // Passa l'oggetto utente corrente da AuthManager, o null se AuthManager non è pronto o utente non c'è
            window.updateGlobalUserUI(window.authManager ? window.authManager.currentUser : null);
        } else console.warn("[AuthUI Landing] window.updateGlobalUserUI non definita durante initialize.");
        window.removeEventListener('resize', setupModalOrientation);
        window.addEventListener('resize', setupModalOrientation);
        setupModalOrientation();
        console.log("[AuthUI Landing] Initialize completato (v1.2).");
    }
    function handleAuthEvent(event) {
        const detail = event.detail;
        console.log("[AuthUI Landing] Received auth event:", detail.type, detail);
        const callGlobalUpdateUI = (userObject = null)=>{
            if (typeof window.updateGlobalUserUI === 'function') {
                // Se l'evento non fornisce direttamente l'utente (es. 'logout-success'),
                // proviamo a prenderlo da authManager, altrimenti passiamo null.
                const userToPass = userObject !== undefined ? userObject : window.authManager ? window.authManager.currentUser : null;
                window.updateGlobalUserUI(userToPass);
            } else console.warn("[AuthUI Landing handleAuthEvent] window.updateGlobalUserUI non definita.");
        };
        switch(detail.type){
            case 'auth-success':
                callGlobalUpdateUI(window.authManager ? window.authManager.currentUser : null);
                hideLoading();
                hideModals(); // Nasconde modali se l'utente si logga in background o ricarica pagina loggato
                break;
            case 'auth-logout':
                callGlobalUpdateUI(null);
                hideLoading();
                break;
            case 'login-success':
            case 'register-success':
            case 'google-success':
                hideModals();
                callGlobalUpdateUI(window.authManager ? window.authManager.currentUser : null); // Passa l'utente corrente
                hideLoading();
                break;
            case 'logout-success':
                callGlobalUpdateUI(null);
                hideLoading();
                break;
            case 'reset-success':
                if (resetSuccess) {
                    resetSuccess.textContent = 'Email inviata! Controlla la tua casella di posta.';
                    resetSuccess.style.display = 'block';
                }
                hideLoading();
                break;
            case 'login-error':
                if (loginError && detail.error) loginError.textContent = getAuthErrorMessage(detail.error);
                hideLoading();
                break;
            case 'register-error':
                if (registerError && detail.error) registerError.textContent = getAuthErrorMessage(detail.error);
                hideLoading();
                break;
            case 'google-error':
                const activeErrorEl = loginModal?.style.display === 'flex' ? loginError : registerError;
                if (activeErrorEl && detail.error && detail.error !== 'auth/popup-closed-by-user' && detail.error !== 'auth/cancelled-popup-request') activeErrorEl.textContent = getAuthErrorMessage(detail.error);
                hideLoading();
                break;
            case 'reset-error':
                if (resetError && detail.error) resetError.textContent = getAuthErrorMessage(detail.error);
                hideLoading();
                break;
            case 'logout-error':
                console.error("Errore logout:", detail.error);
                callGlobalUpdateUI(null); // Aggiorna UI allo stato di errore/logout
                hideLoading();
                break;
            case 'auth-loading':
                showLoading();
                break;
            case 'auth-ui-hidden':
                hideLoading();
                break;
        }
    }
    function showLoginModal() {
        if (!loginModal) return;
        hideModals();
        loginModal.style.display = 'flex';
        setupModalOrientation();
        const emailInput = document.getElementById('login-email');
        if (emailInput) setTimeout(()=>emailInput.focus(), 100);
        if (loginError) loginError.textContent = '';
    }
    function showRegisterModal() {
        if (!registerModal) return;
        hideModals();
        registerModal.style.display = 'flex';
        setupModalOrientation();
        const emailInput = document.getElementById('register-email');
        if (emailInput) setTimeout(()=>emailInput.focus(), 100);
        if (registerError) registerError.textContent = '';
    }
    function showResetModal() {
        if (!resetModal) return;
        hideModals();
        resetModal.style.display = 'flex';
        const emailInput = document.getElementById('reset-email');
        if (emailInput) setTimeout(()=>emailInput.focus(), 100);
        if (resetError) resetError.textContent = '';
        if (resetSuccess) resetSuccess.style.display = 'none';
    }
    function hideModals() {
        if (loginModal) loginModal.style.display = 'none';
        if (registerModal) registerModal.style.display = 'none';
        if (resetModal) resetModal.style.display = 'none';
    }
    function showLoading() {
        if (loading) loading.style.display = 'flex';
    }
    function hideLoading() {
        if (loading) loading.style.display = 'none';
    }
    function setupModalOrientation() {
        const isLikelyMobile = window.matchMedia('(pointer: coarse)').matches;
        const isLandscape = window.innerWidth > window.innerHeight;
        const loginPortraitFooter = document.querySelector('#login-modal .portrait-footer');
        const loginLandscapeFooter = document.querySelector('#login-modal .landscape-footer');
        const registerPortraitFooter = document.querySelector('#register-modal .portrait-footer');
        const registerLandscapeFooter = document.querySelector('#register-modal .landscape-footer');
        if (isLikelyMobile && isLandscape) {
            if (loginPortraitFooter) loginPortraitFooter.style.display = 'none';
            if (loginLandscapeFooter) loginLandscapeFooter.style.display = 'block';
            if (registerPortraitFooter) registerPortraitFooter.style.display = 'none';
            if (registerLandscapeFooter) registerLandscapeFooter.style.display = 'block';
            document.querySelectorAll('#login-modal .form-separator, #register-modal .form-separator').forEach((el)=>{
                if (el.closest('.portrait-footer')) el.style.display = 'none';
            });
        } else {
            if (loginPortraitFooter) loginPortraitFooter.style.display = 'block';
            if (loginLandscapeFooter) loginLandscapeFooter.style.display = 'none';
            if (registerPortraitFooter) registerPortraitFooter.style.display = 'block';
            if (registerLandscapeFooter) registerLandscapeFooter.style.display = 'none';
            document.querySelectorAll('.portrait-footer .form-separator').forEach((el)=>el.style.display = 'flex');
        }
    }
    function setupLandingPageEventListeners() {
        console.log("[AuthUI Landing] Attaching Landing Page Listeners (v1.2)...");
        const btnLogin = document.getElementById('btn-login');
        if (btnLogin) btnLogin.addEventListener('click', showLoginModal);
        const btnRegister = document.getElementById('btn-register');
        if (btnRegister) btnRegister.addEventListener('click', showRegisterModal);
        const gotoRegisterLandscape = document.querySelector('#login-modal .landscape-footer #goto-register');
        if (gotoRegisterLandscape) gotoRegisterLandscape.addEventListener('click', showRegisterModal);
        const gotoLoginLandscape = document.querySelector('#register-modal .landscape-footer #goto-login');
        if (gotoLoginLandscape) gotoLoginLandscape.addEventListener('click', showLoginModal);
        const gotoRegisterPortrait = document.getElementById('goto-register-portrait');
        if (gotoRegisterPortrait) gotoRegisterPortrait.addEventListener('click', showRegisterModal);
        const gotoLoginPortrait = document.getElementById('goto-login-portrait');
        if (gotoLoginPortrait) gotoLoginPortrait.addEventListener('click', showLoginModal);
        const forgotPasswordLinks = document.querySelectorAll('#forgot-password, #forgot-password-portrait');
        forgotPasswordLinks.forEach((link)=>{
            if (link) link.addEventListener('click', function(e) {
                e.preventDefault();
                showResetModal();
                const le = document.getElementById('login-email');
                const re = document.getElementById('reset-email');
                if (le && re && le.value) re.value = le.value;
            });
        });
        const resetBack = document.getElementById('reset-back');
        if (resetBack) resetBack.addEventListener('click', showLoginModal);
        const closeButtons = document.querySelectorAll('.modal-close');
        closeButtons.forEach((button)=>{
            button.addEventListener('click', hideModals);
        });
        const btnLogout = document.getElementById('btn-logout');
        if (btnLogout && window.authManager) btnLogout.addEventListener('click', function() {
            if (window.authManager) window.authManager.logout();
        });
        if (loginForm && window.authManager) loginForm.addEventListener('submit', function(e) {
            e.preventDefault();
            const email = document.getElementById('login-email').value;
            const password = document.getElementById('login-password').value;
            if (window.authManager) window.authManager.loginWithEmailPassword(email, password, loginError);
        });
        if (registerForm && window.authManager) registerForm.addEventListener('submit', function(e) {
            e.preventDefault();
            const email = document.getElementById('register-email').value;
            const password = document.getElementById('register-password').value;
            const name = document.getElementById('register-name').value;
            if (window.authManager) window.authManager.registerWithEmailPassword(email, password, name, registerError);
        });
        if (resetForm && window.authManager) resetForm.addEventListener('submit', function(e) {
            e.preventDefault();
            const email = document.getElementById('reset-email').value;
            if (window.authManager) window.authManager.sendPasswordResetEmail(email, resetError, resetSuccess);
        });
        const googleLoginHandler = function() {
            if (window.authManager) {
                window.authManager.loginWithGoogle().catch(()=>{
                    hideLoading();
                });
                showLoading();
            }
        };
        const googleLoginBtnLandscape = document.getElementById('google-login');
        if (googleLoginBtnLandscape) googleLoginBtnLandscape.addEventListener('click', googleLoginHandler);
        const googleLoginBtnPortrait = document.getElementById('google-login-portrait');
        if (googleLoginBtnPortrait) googleLoginBtnPortrait.addEventListener('click', googleLoginHandler);
        const googleRegisterBtnLandscape = document.getElementById('google-register');
        if (googleRegisterBtnLandscape) googleRegisterBtnLandscape.addEventListener('click', googleLoginHandler);
        const googleRegisterBtnPortrait = document.getElementById('google-register-portrait');
        if (googleRegisterBtnPortrait) googleRegisterBtnPortrait.addEventListener('click', googleLoginHandler);
        console.log("[AuthUI Landing] Landing Page Listeners Attached (v1.2).");
    }
    function getAuthErrorMessage(errorCode) {
        switch(errorCode){
            case 'auth/invalid-email':
                return 'Formato email non valido.';
            case 'auth/user-disabled':
                return 'Account disabilitato.';
            case 'auth/user-not-found':
            case 'auth/invalid-credential':
                return 'Nessun account trovato o credenziali errate.';
            case 'auth/wrong-password':
                return 'Password errata.';
            case 'auth/email-already-in-use':
                return "Email gi\xe0 registrata.";
            case 'auth/weak-password':
                return 'Password min 6 caratteri.';
            case 'auth/operation-not-allowed':
                return 'Operazione non permessa.';
            case 'auth/invalid-login-credentials':
                return 'Credenziali non valide.';
            case 'auth/popup-closed-by-user':
                return 'Accesso Google annullato.';
            case 'auth/cancelled-popup-request':
                return 'Richiesta Google annullata.';
            case 'missing-credentials':
                return 'Inserisci email e password.';
            case 'missing-email':
                return 'Inserisci l\'email.';
            case 'missing-name':
                return 'Inserisci nome giocatore.';
            default:
                return 'Errore sconosciuto. Riprova.';
        }
    }
    return {
        initialize: initialize,
        showLoginModal: showLoginModal,
        showRegisterModal: showRegisterModal,
        showResetModal: showResetModal,
        hideModals: hideModals
    };
}(); // --- END OF FILE public/landingpage/js/auth-ui.js ---


/**
 * landingpage/js/leaderboard-ui.js v2.0 - Truncation Limit Increased
 * Gestione dell'interfaccia utente della classifica nella landing page.
 * MODIFICATO: Aumentato limite troncamento nickname a 20 caratteri.
 * MANTIENE: Espansione Condizionale Leaderboard v1.9, caching, etc.
 */ window.LandingPageLeaderboardUI = function() {
    // Riferimenti agli elementi del DOM
    let leaderboardContainer;
    let leaderboardBody;
    let leaderboardArrow;
    let leaderboardToggleButton; // Pulsante accanto a GIOCA ORA
    let leaderboardTitle;
    const maxScoresToLoad = 10;
    // Stato interno
    let isLoading = false;
    let currentView = 'weekly';
    let weeklyScores = null;
    let allTimeScores = null;
    let scoresData = []; // Mantiene i dati attualmente visualizzati per riferimento
    /** Inizializza il modulo */ function initialize() {
        if (window.LandingPageLeaderboardUI.initialized) return;
        window.LandingPageLeaderboardUI.initialized = true;
        console.log('[LBS UI Landing] Initializing (v2.0 - Truncation 20)...');
        leaderboardContainer = document.getElementById('leaderboard-container');
        leaderboardBody = document.getElementById('leaderboard-body');
        leaderboardArrow = document.getElementById('leaderboard-arrow');
        leaderboardToggleButton = document.getElementById('leaderboard-button'); // Riferimento corretto
        leaderboardTitle = document.getElementById('leaderboard-title');
        if (!leaderboardContainer || !leaderboardBody || !leaderboardArrow || !leaderboardToggleButton || !leaderboardTitle) {
            console.error("[LBS UI Landing] Errore Critico: Elementi UI leaderboard mancanti!");
            if (leaderboardToggleButton) leaderboardToggleButton.disabled = true;
            return;
        }
        // Imposta stato iniziale UI
        leaderboardTitle.textContent = "CLASSIFICA SETTIMANALE";
        leaderboardToggleButton.innerHTML = "CLASSIFICA<br>ALL-TIME";
        leaderboardToggleButton.classList.add('two-lines');
        leaderboardToggleButton.style.textAlign = 'center';
        currentView = 'weekly';
        leaderboardBody.innerHTML = '<tr><td colspan="3" style="text-align: center; padding: 20px;">In attesa di caricamento...</td></tr>';
        leaderboardContainer.classList.remove('leaderboard-expanded');
        leaderboardArrow.classList.remove('arrow-up', 'visible');
        leaderboardContainer.style.cursor = 'default';
        setupEventListeners();
        console.log('[LBS UI Landing] Initialized (v2.0).');
    }
    /** Attacca gli event listener statici (toggle vista) */ function setupEventListeners() {
        console.log("[LBS UI Landing] Setup Event Listeners Statici (v2.0)...");
        const safeAddListener = (element, event, handler)=>{
            if (element && document.body.contains(element)) {
                element.removeEventListener(event, handler);
                element.addEventListener(event, handler);
                return true;
            }
            return false;
        };
        if (!safeAddListener(leaderboardToggleButton, 'click', toggleLeaderboardView)) console.warn("[LBS UI] Impossibile aggiungere listener a leaderboardToggleButton.");
        // Listener per 'click' su leaderboardContainer gestito da renderLeaderboard.
        console.log("[LBS UI Landing] Event listeners statici configurati.");
    }
    /** Espande/Comprime la visualizzazione (chiamata solo se il listener è attivo) */ function toggleLeaderboardExpansion(event) {
        if (!leaderboardContainer || !leaderboardArrow || !leaderboardToggleButton) return;
        if (event.target === leaderboardToggleButton || leaderboardToggleButton.contains(event.target)) {
            console.log("[LBS UI] Click su toggle vista ignorato per espansione.");
            return;
        }
        const isExpanded = leaderboardContainer.classList.toggle('leaderboard-expanded');
        leaderboardArrow.classList.toggle('arrow-up', isExpanded);
        console.log(`[LBS UI] Leaderboard expansion toggled via container: ${isExpanded}`);
    }
    /** Cambia la vista tra Classifica Settimanale e All-Time */ function toggleLeaderboardView() {
        if (isLoading || !leaderboardTitle || !leaderboardToggleButton) return;
        const nextView = currentView === 'weekly' ? 'alltime' : 'weekly';
        console.log(`[LBS UI Toggle] Switching view from ${currentView} to ${nextView}`);
        currentView = nextView;
        leaderboardTitle.textContent = currentView === 'weekly' ? "CLASSIFICA SETTIMANALE" : "CLASSIFICA ALL-TIME";
        if (currentView === 'weekly') leaderboardToggleButton.innerHTML = "CLASSIFICA<br>ALL-TIME";
        else leaderboardToggleButton.innerHTML = "CLASSIFICA<br>SETTIMANALE";
        leaderboardToggleButton.classList.add('two-lines');
        leaderboardToggleButton.style.textAlign = 'center';
        const cachedData = currentView === 'weekly' ? weeklyScores : allTimeScores;
        if (cachedData !== null) renderLeaderboard(cachedData);
        else loadLeaderboard(currentView);
    }
    /** Carica i punteggi dalla classifica specificata */ async function loadLeaderboard(type) {
        // ... (invariato v1.9) ...
        if (isLoading) {
            console.warn(`[LBS UI Load ${type}] Caricamento gi\xe0 in corso.`);
            return;
        }
        const managerExists = window.leaderboardManager;
        const methodName = type === 'weekly' ? 'getWeeklyTopScores' : 'getAllTimeTopScores';
        const methodExists = typeof window.leaderboardManager?.[methodName] === 'function';
        if (!managerExists || !methodExists) {
            console.error(`[LBS UI Load ${type}] Errore FATALE: leaderboardManager o metodo ${methodName} mancante!`);
            if (leaderboardBody) leaderboardBody.innerHTML = `<tr><td colspan="3" style="text-align: center; padding: 20px; color: #FF6666;">Errore Manager (${type})</td></tr>`;
            if (leaderboardArrow) leaderboardArrow.classList.remove('visible', 'arrow-up');
            return;
        }
        isLoading = true;
        console.log(`[LBS UI Load ${type}] Avvio caricamento...`);
        if (leaderboardBody) leaderboardBody.innerHTML = `<tr><td colspan="3" style="text-align: center; padding: 20px;">Caricamento ${type === 'weekly' ? 'settimanale' : 'all-time'}...</td></tr>`;
        if (leaderboardArrow) leaderboardArrow.classList.remove('visible', 'arrow-up');
        try {
            let scores = [];
            scores = await window.leaderboardManager[methodName](maxScoresToLoad);
            scoresData = scores || [];
            if (type === 'weekly') weeklyScores = scoresData;
            else allTimeScores = scoresData;
            console.log(`[LBS UI Load ${type}] Punteggi ricevuti:`, scoresData.length);
            if (currentView === type) renderLeaderboard(scoresData);
            else {
                console.log(`[LBS UI Load ${type}] Dati caricati, ma vista cambiata a ${currentView}. Non renderizzo.`);
                updateExpandability(scoresData.length);
            }
        } catch (error) {
            console.error(`[LBS UI Load ${type}] Errore durante il processo di caricamento classifica:`, error);
            scoresData = [];
            if (currentView === type && leaderboardBody) {
                leaderboardBody.innerHTML = `<tr><td colspan="3" style="text-align: center; padding: 20px; color: #FF6666;">Errore caricamento ${type === 'weekly' ? 'settimanale' : 'all-time'}</td></tr>`;
                renderLeaderboard([]);
            }
        } finally{
            isLoading = false;
            console.log(`[LBS UI Load ${type}] Caricamento terminato.`);
        }
    }
    /** Renderizza la classifica e aggiorna lo stato di espandibilità. */ function renderLeaderboard(scores) {
        if (!leaderboardBody || !leaderboardContainer || !leaderboardArrow) {
            console.error('[LBS UI Render] Elementi UI non trovati per render.');
            return;
        }
        console.log(`[LBS UI Render] Renderizzo ${scores.length} punteggi per vista ${currentView}`);
        leaderboardBody.innerHTML = '';
        if (!Array.isArray(scores) || scores.length === 0) leaderboardBody.innerHTML = `<tr><td colspan="3" style="text-align: center; padding: 20px;">Nessun punteggio ${currentView === 'weekly' ? 'questa settimana' : 'registrato'}.</td></tr>`;
        else scores.forEach((score, index)=>{
            const row = document.createElement('tr');
            const rankClass = index < 3 ? `rank-${index + 1}` : '';
            // ** MODIFICATO: Limite troncamento a 20 caratteri **
            const displayName = score.name ? escapeHtml(score.name.substring(0, 20)) : 'Giocatore';
            const displayScore = formatScore(score.score);
            const displayPosition = score.position || index + 1;
            row.innerHTML = ` <td class="${rankClass}">${displayPosition}</td> <td>${displayName}</td> <td>${displayScore}</td> `;
            leaderboardBody.appendChild(row);
        });
        // Resetta stato espansione e aggiorna
        leaderboardContainer.classList.remove('leaderboard-expanded');
        leaderboardArrow.classList.remove('arrow-up');
        updateExpandability(scores.length);
        console.log('[LBS UI Render] Classifica aggiornata.');
    }
    /** Aggiorna visibilità freccia e listener click container in base al numero di score */ function updateExpandability(scoreCount) {
        // ... (invariato v1.9) ...
        if (!leaderboardContainer || !leaderboardArrow) return;
        leaderboardContainer.removeEventListener('click', toggleLeaderboardExpansion);
        if (scoreCount > 3) {
            leaderboardArrow.classList.add('visible');
            leaderboardContainer.addEventListener('click', toggleLeaderboardExpansion);
            leaderboardContainer.style.cursor = 'pointer';
        } else {
            leaderboardArrow.classList.remove('visible');
            leaderboardContainer.style.cursor = 'default';
        }
    }
    /** Funzione helper per l'escape di HTML. */ function escapeHtml(unsafe) {
        if (unsafe === null || typeof unsafe === 'undefined') return "";
        const str = String(unsafe);
        return str.replace(/&/g, "&").replace(/</g, "<").replace(/>/g, ">").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
    }
    /** Formatta i punteggi */ function formatScore(score) {
        if (typeof score !== 'number' || isNaN(score)) return '0';
        return score.toLocaleString('it-IT');
    }
    // API Pubblica
    return {
        initialize: initialize,
        loadLeaderboard: loadLeaderboard
    };
}(); // --- END OF FILE public/landingpage/js/leaderboard-ui.js ---


// --- START OF FILE public/js/landingpage/js/profile-ui.js ---
/**
 * landingpage/js/profile-ui.js v1.33.4 - COMPLETE Full Restore & All Fixes
 * Gestisce l'UI del modale profilo (#profile-modal) sulla landing page.
 * MODIFICATO: Ripristinato il corpo completo di TUTTE le funzioni con la loro logica corretta.
 * MANTIENE: Corretta popolazione del riepilogo achievement.
 * MANTIENE: Uso corretto di achDef.icon (URL da Parcel) per le icone.
 * MANTIENE: Human-Readable Week ID Formatting v1.32.
 * MANTIENE: Rimozione fallback a placeholder per le icone.
 * MANTIENE: Rimozione refetch ridondante in handleCopyTrophiesClick v1.31.
 */ window.LandingPageProfileUI = function() {
    let profileManagerInstance = null;
    let achievementManagerInstance = null;
    let profileModal = null, profileCloseBtn = null, userNameElement = null;
    let tabButtons = [], tabContents = [];
    let displayNameEl = null, emailEl = null, createdAtEl = null, lastLoginEl = null;
    let highScoreAllTimeEl = null, topScoresAllTimeListEl = null;
    let topScoresWeeklyListEl = null, weeklyInfoEl = null;
    let redeemBtn = null, codeInput = null, redeemErrorEl = null, redeemSuccessEl = null;
    let shareXButton = null, copyStatsButton = null;
    let shareTrophiesXButton = null;
    let copyTrophiesButton = null;
    let achievementsTabContent = null, achievementsSummaryContainer = null, achievementsGridContainer = null;
    let achievementDetailPopup = null, achievementDetailCloseBtn = null, achievementDetailBody = null;
    let isInitialized = false, isLoadingProfile = false, copyTimeout = null, copyTrophiesTimeout = null;
    function formatWeekIdToDateRange(weekIdString) {
        try {
            if (!weekIdString || !/^\d{4}-W\d{1,2}$/.test(weekIdString)) throw new Error("Formato weekId non valido.");
            const parts = weekIdString.split('-W');
            const year = parseInt(parts[0], 10);
            const weekNo = parseInt(parts[1], 10);
            if (isNaN(year) || isNaN(weekNo) || weekNo < 1 || weekNo > 53) throw new Error("Anno o numero settimana non validi.");
            const jan4 = new Date(Date.UTC(year, 0, 4));
            const dayOfWeekJan4 = jan4.getUTCDay();
            const isoDayOfWeekJan4 = dayOfWeekJan4 === 0 ? 7 : dayOfWeekJan4;
            const mondayOfJan4Week = new Date(jan4);
            mondayOfJan4Week.setUTCDate(jan4.getUTCDate() - isoDayOfWeekJan4 + 1);
            const startDate = new Date(mondayOfJan4Week);
            startDate.setUTCDate(mondayOfJan4Week.getUTCDate() + (weekNo - 1) * 7);
            const endDate = new Date(startDate);
            endDate.setUTCDate(startDate.getUTCDate() + 6);
            const formatOptions = {
                day: 'numeric',
                month: 'short'
            };
            const startFormatted = startDate.toLocaleDateString('it-IT', formatOptions);
            const endFormatted = endDate.toLocaleDateString('it-IT', formatOptions);
            const yearFormatted = startDate.getUTCFullYear();
            return `${startFormatted} - ${endFormatted} ${yearFormatted}`;
        } catch (error) {
            console.error(`Errore nella formattazione di weekId "${weekIdString}":`, error);
            return weekIdString;
        }
    }
    function initialize(profileMgr, achievementMgr) {
        if (isInitialized) return;
        console.log('[ProfileUI] Initializing (v1.33.4 - Full Restore)...');
        profileManagerInstance = profileMgr;
        achievementManagerInstance = achievementMgr;
        if (!profileManagerInstance || !achievementManagerInstance) console.error("[ProfileUI Initialize Error] Istanze manager non fornite!");
        profileModal = document.getElementById('profile-modal');
        if (!profileModal) {
            console.error('[ProfileUI Error] Modale #profile-modal non trovato.');
            return;
        }
        profileCloseBtn = findEl('#profile-close');
        userNameElement = document.getElementById('user-name');
        tabButtons = Array.from(profileModal.querySelectorAll('.tab-button'));
        tabContents = Array.from(profileModal.querySelectorAll('.profile-tab-content'));
        displayNameEl = findEl('#profile-displayName');
        emailEl = findEl('#profile-email');
        createdAtEl = findEl('#profile-createdAt');
        lastLoginEl = findEl('#profile-lastLogin');
        highScoreAllTimeEl = findEl('#profile-highScore');
        topScoresAllTimeListEl = findEl('#profile-top-alltime-list');
        topScoresWeeklyListEl = findEl('#profile-top-weekly-list');
        weeklyInfoEl = findEl('#profile-weekly-info');
        const codesContent = findEl('#profile-codes');
        if (codesContent) {
            redeemBtn = codesContent.querySelector('#redeem-code-button');
            codeInput = codesContent.querySelector('#redeem-code-input');
            redeemErrorEl = codesContent.querySelector('#redeem-code-error');
            redeemSuccessEl = codesContent.querySelector('#redeem-code-success');
        }
        shareXButton = findEl('#share-x-button');
        copyStatsButton = findEl('#copy-stats-button');
        achievementsTabContent = findEl('#profile-achievements');
        if (achievementsTabContent) {
            achievementsSummaryContainer = achievementsTabContent.querySelector('#profile-achievements-summary');
            achievementsGridContainer = achievementsTabContent.querySelector('#profile-achievements-grid');
        }
        achievementDetailPopup = document.getElementById('profile-achievement-detail-popup');
        if (achievementDetailPopup) {
            achievementDetailCloseBtn = achievementDetailPopup.querySelector('#achievement-detail-close');
            achievementDetailBody = achievementDetailPopup.querySelector('#achievement-detail-body');
        }
        shareTrophiesXButton = findEl('#share-trophies-x-button');
        copyTrophiesButton = findEl('#copy-trophies-button');
        setupEventListeners();
        isInitialized = true;
        console.log('[ProfileUI] Initialized successfully (v1.33.4).');
    }
    function findEl(selector) {
        return profileModal ? profileModal.querySelector(selector) : null;
    }
    function setupEventListeners() {
        const addListener = (element, event, handler, scope = window)=>{
            if (element && (element === userNameElement || document.body.contains(element))) {
                element.removeEventListener(event, handler);
                element.addEventListener(event, handler.bind(scope));
            }
        };
        addListener(userNameElement, 'click', openProfileModal, this);
        addListener(profileCloseBtn, 'click', closeProfileModal, this);
        tabButtons.forEach((button)=>{
            addListener(button, 'click', handleTabClick, this);
        });
        if (profileModal) {
            profileModal.removeEventListener('click', handleModalBackgroundClick);
            profileModal.addEventListener('click', handleModalBackgroundClick.bind(this));
        }
        addListener(redeemBtn, 'click', handleRedeemCodeClick, this);
        addListener(shareXButton, 'click', handleShareStatsXClick, this);
        addListener(copyStatsButton, 'click', handleCopyStatsClick, this);
        addListener(achievementDetailCloseBtn, 'click', closeAchievementDetailPopup, this);
        if (achievementDetailPopup) {
            achievementDetailPopup.removeEventListener('click', handleDetailPopupBackgroundClick);
            achievementDetailPopup.addEventListener('click', handleDetailPopupBackgroundClick.bind(this));
        }
        console.log("[ProfileUI setupEventListeners] Listener registrati.");
    }
    function handleModalBackgroundClick(event) {
        if (event.target === profileModal) closeProfileModal();
    }
    function handleTabClick(event) {
        const tabId = event.currentTarget.getAttribute('data-tab');
        if (!tabId || !profileModal) return;
        if (typeof switchProfileTab === 'function') switchProfileTab(tabId);
        else {
            tabContents.forEach((c)=>{
                c.style.display = 'none';
                c.classList.remove('active');
            });
            tabButtons.forEach((b)=>b.classList.remove('active'));
            const aC = findEl(`#profile-${tabId}`);
            if (aC) {
                aC.style.display = 'block';
                aC.classList.add('active');
            }
            event.currentTarget.classList.add('active');
        }
        if (tabId === 'achievements') populateAchievementsTab();
    }
    async function openProfileModal() {
        if (!profileModal || isLoadingProfile) return;
        isLoadingProfile = true;
        try {
            if (!profileManagerInstance || !window.authManager) throw new Error("Manager Profile o Auth mancanti");
            profileModal.style.display = 'flex';
            profileModal.style.zIndex = '10000';
            profileModal.style.position = 'fixed';
            displayLoadingState();
            if (window.authManager.isAuthenticated()) await profileManagerInstance.loadUserCache(window.authManager);
            populateProfileData();
            const firstTabButton = findEl('.tab-button[data-tab="general"]');
            if (firstTabButton) {
                if (typeof switchProfileTab === 'function') switchProfileTab('general');
                else handleTabClick({
                    currentTarget: firstTabButton
                });
            }
            if (profileModal.style.display !== 'flex') profileModal.style.display = 'flex';
        } catch (error) {
            console.error("[ProfileUI] Errore apertura modale:", error);
            closeProfileModal();
        } finally{
            isLoadingProfile = false;
        }
    }
    function displayLoadingState() {
        if (displayNameEl) displayNameEl.textContent = 'Caricamento...';
        if (emailEl) emailEl.textContent = '...';
        if (createdAtEl) createdAtEl.textContent = '...';
        if (lastLoginEl) lastLoginEl.textContent = '...';
        if (highScoreAllTimeEl) highScoreAllTimeEl.textContent = '...';
        if (topScoresAllTimeListEl) topScoresAllTimeListEl.innerHTML = '<li>Caricamento...</li>';
        if (topScoresWeeklyListEl) topScoresWeeklyListEl.innerHTML = '<li>Caricamento...</li>';
        if (weeklyInfoEl) weeklyInfoEl.textContent = 'Settimana: Caricamento...';
        if (shareXButton) shareXButton.style.opacity = '0.5';
        if (copyStatsButton) copyStatsButton.style.opacity = '0.5';
        if (achievementsSummaryContainer) {
            const podium = achievementsSummaryContainer.querySelector('.achievement-podium');
            const progress = achievementsSummaryContainer.querySelector('.achievement-progress');
            if (podium) podium.innerHTML = '<span>Caricamento...</span>';
            if (progress) progress.innerHTML = '<p>Caricamento...</p>';
        }
        if (achievementsGridContainer) achievementsGridContainer.innerHTML = '<p>Caricamento griglia trofei...</p>';
        const sxBtnT = findEl('#share-trophies-x-button');
        const cpBtnT = findEl('#copy-trophies-button');
        if (sxBtnT) sxBtnT.style.opacity = '0.5';
        if (cpBtnT) cpBtnT.style.opacity = '0.5';
    }
    function closeProfileModal() {
        if (profileModal) profileModal.style.display = 'none';
        closeAchievementDetailPopup();
    }
    function populateProfileData() {
        if (!profileManagerInstance) {
            displayLoadingState();
            return;
        }
        const userData = profileManagerInstance.getUserData();
        if (!userData || !window.authManager?.isAuthenticated()) {
            if (displayNameEl) displayNameEl.textContent = 'Ospite';
            if (emailEl) emailEl.textContent = 'N/D';
            if (createdAtEl) createdAtEl.textContent = 'N/D';
            if (lastLoginEl) lastLoginEl.textContent = 'N/D';
            if (highScoreAllTimeEl) highScoreAllTimeEl.textContent = 'Accedi per vedere';
            if (topScoresAllTimeListEl) renderTopScoresList(topScoresAllTimeListEl, [], 'Accedi per vedere');
            if (topScoresWeeklyListEl) renderTopScoresList(topScoresWeeklyListEl, [], 'Accedi per vedere');
            if (weeklyInfoEl) weeklyInfoEl.textContent = 'Settimana: N/D';
            if (shareXButton) shareXButton.style.opacity = '0.3';
            if (copyStatsButton) copyStatsButton.style.opacity = '0.3';
            if (achievementsSummaryContainer) {
                const p = achievementsSummaryContainer.querySelector('.achievement-podium');
                const pr = achievementsSummaryContainer.querySelector('.achievement-progress');
                if (p) p.innerHTML = '';
                if (pr) pr.innerHTML = '<p>Accedi per vedere i trofei.</p>';
            }
            if (achievementsGridContainer) achievementsGridContainer.innerHTML = '<p>Accedi per vedere i trofei.</p>';
            const sxBtnT = findEl('#share-trophies-x-button');
            const cpBtnT = findEl('#copy-trophies-button');
            if (sxBtnT) sxBtnT.style.opacity = '0.3';
            if (cpBtnT) {
                cpBtnT.style.opacity = '0.3';
                cpBtnT.classList.remove('copied');
            }
            return;
        }
        if (displayNameEl) displayNameEl.textContent = userData.displayName || 'N/D';
        if (emailEl) emailEl.textContent = userData.email || 'N/D';
        try {
            const cAt = userData.createdAt instanceof Date && !isNaN(userData.createdAt) ? userData.createdAt : null;
            const lLi = userData.lastLogin instanceof Date && !isNaN(userData.lastLogin) ? userData.lastLogin : null;
            if (createdAtEl) createdAtEl.textContent = cAt ? cAt.toLocaleDateString('it-IT', {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            }) : 'N/D';
            if (lastLoginEl) lastLoginEl.textContent = lLi ? lLi.toLocaleString('it-IT', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            }) : 'N/D';
        } catch (e) {
            console.error("[ProfileUI] Errore date:", e);
            if (createdAtEl) createdAtEl.textContent = 'Err';
            if (lastLoginEl) lastLoginEl.textContent = 'Err';
        }
        const stats = userData.stats || {};
        if (highScoreAllTimeEl) highScoreAllTimeEl.textContent = "\uD83C\uDFC6 " + formatScore(stats.highScoreAllTime || 0);
        if (topScoresAllTimeListEl) renderTopScoresList(topScoresAllTimeListEl, stats.topScoresAllTime, 'Nessun punteggio registrato');
        if (topScoresWeeklyListEl && weeklyInfoEl) {
            const currentWeekId = stats.currentWeekIdForTopScores || profileManagerInstance?.getWeekId() || 'N/D';
            let displayWeekText = `Settimana: ${currentWeekId}`;
            if (currentWeekId !== 'N/D') try {
                displayWeekText = `Settimana: ${formatWeekIdToDateRange(currentWeekId)}`;
            } catch (e) {
                console.warn(`[ProfileUI] Errore formattazione week ID "${currentWeekId}" in populateProfileData:`, e);
            }
            weeklyInfoEl.textContent = displayWeekText;
            renderTopScoresList(topScoresWeeklyListEl, stats.topScoresWeekly, 'Nessun punteggio questa settimana');
        }
        if (codeInput) codeInput.value = '';
        if (redeemErrorEl) {
            redeemErrorEl.textContent = '';
            redeemErrorEl.style.display = 'none';
        }
        if (redeemSuccessEl) {
            redeemSuccessEl.textContent = '';
            redeemSuccessEl.style.display = 'none';
        }
        if (redeemBtn) {
            redeemBtn.disabled = false;
            redeemBtn.textContent = 'Riscatta';
        }
        const hasScores = (stats.highScoreAllTime || 0) > 0;
        if (shareXButton) shareXButton.style.opacity = hasScores ? '0.7' : '0.3';
        if (copyStatsButton) copyStatsButton.style.opacity = hasScores ? '0.7' : '0.3';
        if (achievementsSummaryContainer) {
            const p = achievementsSummaryContainer.querySelector('.achievement-podium');
            const pr = achievementsSummaryContainer.querySelector('.achievement-progress');
            if (p) p.innerHTML = '<span>Caricamento...</span>';
            if (pr) pr.innerHTML = '<p>Caricamento...</p>';
        }
        if (achievementsGridContainer) achievementsGridContainer.innerHTML = '<p>Caricamento griglia trofei...</p>';
        const sxBtnT = findEl('#share-trophies-x-button');
        const cpBtnT = findEl('#copy-trophies-button');
        if (sxBtnT) sxBtnT.style.opacity = '0.3';
        if (cpBtnT) {
            cpBtnT.style.opacity = '0.3';
            cpBtnT.classList.remove('copied');
        }
        if (findEl('.tab-button[data-tab="achievements"]')?.classList.contains('active')) populateAchievementsTab();
    }
    async function handleRedeemCodeClick() {
        if (!redeemBtn || !codeInput || !redeemErrorEl || !redeemSuccessEl || !profileManagerInstance) {
            if (redeemErrorEl) redeemErrorEl.textContent = 'Errore interno.';
            return;
        }
        const code = codeInput.value.trim().toUpperCase();
        if (!code) {
            redeemErrorEl.textContent = 'Inserisci un codice.';
            redeemSuccessEl.textContent = '';
            redeemErrorEl.style.display = 'block';
            redeemSuccessEl.style.display = 'none';
            return;
        }
        redeemErrorEl.textContent = '';
        redeemSuccessEl.textContent = '';
        redeemErrorEl.style.display = 'none';
        redeemSuccessEl.style.display = 'none';
        redeemBtn.disabled = true;
        redeemBtn.textContent = 'VERIFICO...';
        try {
            const result = await profileManagerInstance.redeemCode(code);
            if (result.success) {
                redeemSuccessEl.textContent = result.message || 'Codice riscattato!';
                redeemSuccessEl.style.display = 'block';
                if (codeInput) codeInput.value = '';
                populateProfileData();
            } else {
                redeemErrorEl.textContent = result.message || "Codice non valido o gi\xe0 usato.";
                redeemErrorEl.style.display = 'block';
            }
        } catch (redeemError) {
            console.error("[ProfileUI] Errore chiamata profileManager.redeemCode:", redeemError);
            redeemErrorEl.textContent = 'Errore riscatto. Riprova.';
            redeemErrorEl.style.display = 'block';
        } finally{
            if (redeemBtn && document.body.contains(redeemBtn)) {
                redeemBtn.disabled = false;
                redeemBtn.textContent = 'Riscatta';
            }
        }
    }
    function renderTopScoresList(listElement, scoresArray, emptyMessage) {
        if (!listElement) return;
        listElement.innerHTML = '';
        if (scoresArray && Array.isArray(scoresArray) && scoresArray.length > 0) {
            const sortedScores = [
                ...scoresArray
            ].sort((a, b)=>{
                const scoreA = a?.score || 0;
                const scoreB = b?.score || 0;
                const timeA = a?.timestamp instanceof Date ? a.timestamp.getTime() : 0;
                const timeB = b?.timestamp instanceof Date ? b.timestamp.getTime() : 0;
                if (scoreB !== scoreA) return scoreB - scoreA;
                return timeB - timeA;
            }).slice(0, 3);
            const medalEmojis = [
                "\uD83E\uDD47",
                "\uD83E\uDD48",
                "\uD83E\uDD49"
            ];
            sortedScores.forEach((scoreEntry, index)=>{
                if (!scoreEntry || typeof scoreEntry.score === 'undefined') return;
                const li = document.createElement('li');
                li.style.display = 'flex';
                li.style.justifyContent = 'space-between';
                li.style.alignItems = 'baseline';
                li.style.marginBottom = '8px';
                const medal = medalEmojis[index] || `${index + 1}.`;
                let dateStr = 'N/D';
                try {
                    if (scoreEntry.timestamp instanceof Date && !isNaN(scoreEntry.timestamp)) dateStr = scoreEntry.timestamp.toLocaleDateString('it-IT', {
                        day: '2-digit',
                        month: '2-digit',
                        year: '2-digit'
                    });
                } catch (e) {}
                li.innerHTML = ` <div class="score-entry-left"> <span class="rank-medal">${medal}</span> <span class="score-value">${formatScore(scoreEntry.score)}</span> </div> <div class="score-entry-right"> <span class="score-date">(${dateStr})</span> </div> `;
                listElement.appendChild(li);
            });
        } else {
            const li = document.createElement('li');
            li.innerHTML = `<i>${emptyMessage}</i>`;
            li.style.opacity = '0.7';
            listElement.appendChild(li);
        }
    }
    function formatScore(score) {
        if (typeof score !== 'number' || isNaN(score)) return '0';
        return score.toLocaleString('it-IT');
    }
    function generateShareMessages() {
        if (!profileManagerInstance) return null;
        const statsData = profileManagerInstance.getUserStats();
        if (!statsData || (statsData.highScoreAllTime || 0) === 0) return null;
        const baseUrl = "https://pac-maldini.web.app/";
        const mention = "@M4rkPhilips";
        const formatScoreLocal = (s)=>s ? s.toLocaleString('it-IT') : '-';
        const highScore = statsData.highScoreAllTime || 0;
        const topAT = (statsData.topScoresAllTime || []).slice(0, 3);
        const topWk = (statsData.topScoresWeekly || []).slice(0, 3);
        const weekId = statsData.currentWeekIdForTopScores ? formatWeekIdToDateRange(statsData.currentWeekIdForTopScores) : 'N/D';
        const medals = [
            "\uD83E\uDD47",
            "\uD83E\uDD48",
            "\uD83E\uDD49"
        ];
        let msgTxt = `I miei record su PAC-Maldini!

\u{1F3C6} Record Assoluto: ${formatScoreLocal(highScore)}

\u{1F552} Top 3 All-Time:
`;
        if (topAT.length > 0) topAT.forEach((s, i)=>{
            msgTxt += `${medals[i]} ${formatScoreLocal(s.score)}\n`;
        });
        else msgTxt += "-\n";
        msgTxt += `
\u{1F4C5} Top 3 Settimanali (${weekId}):\n`;
        if (topWk.length > 0) topWk.forEach((s, i)=>{
            msgTxt += `${medals[i]} ${formatScoreLocal(s.score)}\n`;
        });
        else msgTxt += "-\n";
        msgTxt += `\nChi fa meglio? ${mention}\n\nGioca anche tu: ${baseUrl}`;
        msgTxt = msgTxt.trim();
        const twitterTxt = encodeURIComponent(msgTxt.replace(baseUrl, '').trim());
        const encUrl = encodeURIComponent(baseUrl);
        let finalTwitterUrl = `https://twitter.com/intent/tweet?text=${twitterTxt}&url=${encUrl}`;
        if (msgTxt.length > 280) {
            const fallbackTxt = `Nuovo record PAC-Maldini! \u{1F3C6}${formatScoreLocal(highScore)} ${mention} Gioca:`;
            const encFallback = encodeURIComponent(fallbackTxt);
            finalTwitterUrl = `https://twitter.com/intent/tweet?text=${encFallback}&url=${encUrl}`;
        }
        return {
            copy: msgTxt,
            twitter: finalTwitterUrl
        };
    }
    function handleShareStatsXClick() {
        const messages = generateShareMessages();
        if (messages?.twitter) window.open(messages.twitter, '_blank');
        else alert("Nessun punteggio o errore preparazione messaggio.");
    }
    function showCopiedFeedback(buttonElement, type) {
        if (!buttonElement) return;
        let timeoutRef = type === 'stats' ? copyTimeout : copyTrophiesTimeout;
        if (timeoutRef) clearTimeout(timeoutRef);
        buttonElement.classList.add('copied');
        timeoutRef = setTimeout(()=>{
            if (buttonElement) buttonElement.classList.remove('copied');
            if (type === 'stats') copyTimeout = null;
            else copyTrophiesTimeout = null;
        }, 1500);
        if (type === 'stats') copyTimeout = timeoutRef;
        else copyTrophiesTimeout = timeoutRef;
    }
    function handleCopyStatsClick() {
        const messages = generateShareMessages();
        if (!messages?.copy) {
            alert("Nessun punteggio o errore preparazione testo.");
            return;
        }
        if (navigator.clipboard?.writeText) navigator.clipboard.writeText(messages.copy).then(()=>showCopiedFeedback(copyStatsButton, 'stats')).catch(()=>alert("Impossibile copiare."));
        else try {
            const ta = document.createElement("textarea");
            ta.value = messages.copy;
            ta.style.position = "fixed";
            ta.style.left = "-9999px";
            document.body.appendChild(ta);
            ta.focus();
            ta.select();
            document.execCommand('copy');
            document.body.removeChild(ta);
            showCopiedFeedback(copyStatsButton, 'stats');
        } catch (err) {
            alert("Copia automatica fallita.");
        }
    }
    function getTierEmoji(tier) {
        switch(tier){
            case 'platinum':
                return "\uD83C\uDFC6";
            case 'gold':
                return "\uD83E\uDD47";
            case 'silver':
                return "\uD83E\uDD48";
            case 'bronze':
                return "\uD83E\uDD49";
            default:
                return "\u2754";
        }
    }
    function populateAchievementsTab() {
        if (!profileManagerInstance || !achievementManagerInstance) {
            if (achievementsGridContainer) achievementsGridContainer.innerHTML = '<p>Errore caricamento manager.</p>';
            return;
        }
        const userData = profileManagerInstance.getUserData();
        const allDefinitions = achievementManagerInstance.getDefinitions();
        if (!userData || !window.authManager?.isAuthenticated()) {
            if (achievementsGridContainer) achievementsGridContainer.innerHTML = '<p>Accedi per vedere i trofei.</p>';
            return;
        }
        if (!allDefinitions || allDefinitions.length === 0) {
            if (achievementsGridContainer) achievementsGridContainer.innerHTML = '<p>Errore caricamento definizioni.</p>';
            return;
        }
        const unlockedAchievements = userData.achievements || {};
        if (achievementsSummaryContainer) populateAchievementsSummary(unlockedAchievements, allDefinitions);
        if (achievementsGridContainer) populateAchievementsGrid(userData, allDefinitions);
        shareTrophiesXButton = findEl('#share-trophies-x-button');
        copyTrophiesButton = findEl('#copy-trophies-button');
        const addListener = (element, event, handler, scope = window)=>{
            if (element) {
                element.removeEventListener(event, handler);
                element.addEventListener(event, handler.bind(scope));
            }
        };
        if (shareTrophiesXButton) addListener(shareTrophiesXButton, 'click', handleShareTrophiesXClick, this);
        if (copyTrophiesButton) addListener(copyTrophiesButton, 'click', handleCopyTrophiesClick, this);
        const unlockedCount = Object.keys(unlockedAchievements).length;
        const enabledOpacity = unlockedCount > 0 ? '0.7' : '0.3';
        if (shareTrophiesXButton) shareTrophiesXButton.style.opacity = enabledOpacity;
        if (copyTrophiesButton) {
            copyTrophiesButton.style.opacity = enabledOpacity;
            copyTrophiesButton.classList.remove('copied');
        }
    }
    function populateAchievementsSummary(unlockedAchievements, allDefinitions) {
        if (!achievementsSummaryContainer) {
            console.warn("[ProfileUI populateAchievementsSummary] achievementsSummaryContainer non trovato.");
            return;
        }
        const totalAchievementsDefinitions = allDefinitions.length;
        const unlockedCount = Object.keys(unlockedAchievements).length;
        const countsByTier = {
            bronze: 0,
            silver: 0,
            gold: 0,
            platinum: 0
        };
        allDefinitions.forEach((achDef)=>{
            if (achDef.tier && countsByTier.hasOwnProperty(achDef.tier)) {
                if (unlockedAchievements[achDef.id]) countsByTier[achDef.tier]++;
            }
        });
        const percentage = totalAchievementsDefinitions > 0 ? Math.round(unlockedCount / totalAchievementsDefinitions * 100) : 0;
        const podiumContainer = achievementsSummaryContainer.querySelector('.achievement-podium');
        const progressContainer = achievementsSummaryContainer.querySelector('.achievement-progress');
        if (podiumContainer) podiumContainer.innerHTML = `
                <span class="podium-item platinum" title="Platino"><span class="podium-emoji">\u{1F3C6}</span> ${countsByTier.platinum}</span>
                <span class="podium-item gold" title="Oro"><span class="podium-emoji">\u{1F947}</span> ${countsByTier.gold}</span>
                <span class="podium-item silver" title="Argento"><span class="podium-emoji">\u{1F948}</span> ${countsByTier.silver}</span>
                <span class="podium-item bronze" title="Bronzo"><span class="podium-emoji">\u{1F949}</span> ${countsByTier.bronze}</span>`;
        else console.warn("[ProfileUI populateAchievementsSummary] podiumContainer non trovato.");
        if (progressContainer) progressContainer.innerHTML = `
                <span class="progress-text">\u{1F9EE} ${percentage}%</span>
                <span class="progress-count">(${unlockedCount}/${totalAchievementsDefinitions})</span>`;
        else console.warn("[ProfileUI populateAchievementsSummary] progressContainer non trovato.");
    }
    function populateAchievementsGrid(userData, allDefinitions) {
        if (!achievementsGridContainer) return;
        achievementsGridContainer.innerHTML = '';
        const unlockedAchievements = userData?.achievements || {};
        const progressTrackers = userData?.progressTrackers || {};
        const tierOrderValue = {
            platinum: 0,
            gold: 1,
            silver: 2,
            bronze: 3,
            default: 4
        };
        const achievementsForSort = allDefinitions.map((ach)=>({
                ...ach,
                isUnlocked: !!unlockedAchievements[ach.id],
                tierValue: tierOrderValue[ach.tier] ?? tierOrderValue.default
            }));
        achievementsForSort.sort((a, b)=>{
            if (a.tierValue !== b.tierValue) return a.tierValue - b.tierValue;
            if (a.isUnlocked !== b.isUnlocked) return a.isUnlocked ? -1 : 1;
            return a.name.localeCompare(b.name);
        });
        achievementsForSort.forEach((ach)=>{
            const achievementElement = document.createElement('button');
            achievementElement.classList.add('achievement-item', `tier-${ach.tier || 'default'}`);
            achievementElement.dataset.achievementId = ach.id;
            achievementElement.title = ach.name;
            let finalIconUrl = ach.icon;
            if (!finalIconUrl) {
                console.warn(`Icona non definita per ach ${ach.id}`);
                finalIconUrl = '#';
                achievementElement.style.backgroundImage = 'none';
            } else achievementElement.style.setProperty('--icon-url', `url('${finalIconUrl}')`);
            const isUnlocked = ach.isUnlocked;
            achievementElement.classList.remove('locked', 'has-progress');
            achievementElement.removeAttribute('data-progress-percent');
            if (isUnlocked) achievementElement.setAttribute('aria-label', `Trofeo Sbloccato: ${ach.name}`);
            else {
                achievementElement.classList.add('locked');
                achievementElement.setAttribute('aria-label', `Trofeo Bloccato: ${ach.name}`);
                const isCounter = ach.criteria?.type === 'counter_reach';
                if (isCounter) {
                    const trackerKey = ach.criteria.counterKey;
                    const targetValue = ach.criteria.count;
                    const currentValue = progressTrackers[trackerKey] || 0;
                    const scope = ach.criteria.scope;
                    if (targetValue > 0) {
                        const percent = Math.min(100, currentValue / targetValue * 100);
                        if (scope === 'lifetime' && percent > 0) {
                            achievementElement.classList.add('has-progress');
                            achievementElement.dataset.progressPercent = Math.floor(percent);
                            achievementElement.style.setProperty('--progress-percent', `${percent}%`);
                        }
                    }
                }
            }
            achievementElement.innerHTML = '';
            achievementElement.removeEventListener('click', handleAchievementClick);
            achievementElement.addEventListener('click', handleAchievementClick.bind(this));
            achievementsGridContainer.appendChild(achievementElement);
        });
    }
    function handleAchievementClick(event) {
        const button = event.currentTarget;
        const achievementId = button.dataset.achievementId;
        if (!achievementId) return;
        showAchievementDetailPopup(achievementId);
    }
    function getTierBorderColor(tier) {
        switch(tier){
            case 'gold':
                return '#FFD700';
            case 'silver':
                return '#C0C0C0';
            case 'bronze':
                return '#CD7F32';
            case 'platinum':
                return '#E5E4E2';
            default:
                return '#555555';
        }
    }
    function showAchievementDetailPopup(achievementId) {
        if (!achievementDetailPopup || !achievementDetailBody || !achievementManagerInstance || !profileManagerInstance) return;
        const achDef = achievementManagerInstance.getAchievement(achievementId);
        const userData = profileManagerInstance.getUserData();
        const unlockedData = userData?.achievements || {};
        if (!achDef) {
            achievementDetailBody.innerHTML = '<p>Errore: Dati trofeo non trovati.</p>';
            achievementDetailPopup.style.display = 'flex';
            return;
        }
        const isUnlocked = !!unlockedData[achDef.id];
        let unlockedDateStr = "Non ancora sbloccato";
        if (isUnlocked && unlockedData[achDef.id] instanceof Date && !isNaN(unlockedData[achDef.id])) try {
            unlockedDateStr = `Sbloccato il: ${unlockedData[achDef.id].toLocaleDateString('it-IT', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            })} alle ${unlockedData[achDef.id].toLocaleTimeString('it-IT', {
                hour: '2-digit',
                minute: '2-digit'
            })}`;
        } catch (e) {
            unlockedDateStr = "Sbloccato (data non valida)";
        }
        else if (isUnlocked) unlockedDateStr = "Sbloccato (data non disponibile)";
        let finalIconUrlPopup = achDef.icon;
        let iconHtmlContent = '';
        if (finalIconUrlPopup) iconHtmlContent = `<div class="achievement-icon-container detail-icon-bg" style="background-image: url('${finalIconUrlPopup}');"></div>`;
        else console.warn(`Icona non definita per dettaglio di ${achDef.id}.`);
        let progressHtml = '';
        if (!isUnlocked && achDef.criteria?.type === 'counter_reach' && achDef.criteria.scope === 'lifetime') {
            const tk = achDef.criteria.counterKey;
            const tgV = achDef.criteria.count;
            const cV = userData?.progressTrackers?.[tk] || 0;
            if (tgV > 0) {
                const p = Math.min(100, cV / tgV * 100);
                const rp = Math.floor(p);
                const cf = formatScore(cV);
                const tf = formatScore(tgV);
                progressHtml = ` <div class="achievement-progress-container"><div class="achievement-progress-bar-bg"><div class="achievement-progress-bar" style="width:${p}%;"></div></div><span class="achievement-progress-text">${cf} / ${tf} (${rp}%)</span></div> `;
            }
        }
        achievementDetailBody.innerHTML = `<div class="achievement-detail-header tier-${achDef.tier} ${isUnlocked ? '' : 'locked'}">${iconHtmlContent}<h3 class="achievement-detail-name">${achDef.name}</h3><span class="achievement-detail-tier">${achDef.tier.toUpperCase()}</span></div><p class="achievement-detail-description">${achDef.description}</p>${progressHtml}<p class="achievement-detail-status">${unlockedDateStr}</p>`;
        const detailContent = achievementDetailPopup.querySelector('.achievement-detail-content');
        if (detailContent) detailContent.style.borderColor = getTierBorderColor(achDef.tier);
        achievementDetailPopup.style.display = 'flex';
    }
    function closeAchievementDetailPopup() {
        if (achievementDetailPopup) achievementDetailPopup.style.display = 'none';
    }
    function handleDetailPopupBackgroundClick(event) {
        if (event.target === achievementDetailPopup) closeAchievementDetailPopup();
    }
    function generateTrophyShareMessages(userData, allDefinitions) {
        if (!userData || !allDefinitions || allDefinitions.length === 0) return null;
        const unlockedAchievements = userData.achievements || {};
        const unlockedCount = Object.keys(unlockedAchievements).length;
        const totalWithPlatinum = allDefinitions.length;
        const totalForPercentage = 40;
        const countsByTier = {
            bronze: 0,
            silver: 0,
            gold: 0,
            platinum: 0
        };
        const goldAchievements = [];
        let platinumData = null;
        allDefinitions.forEach((ach)=>{
            if (ach.tier && countsByTier[ach.tier] !== undefined) {
                if (unlockedAchievements[ach.id]) countsByTier[ach.tier]++;
            }
            if (ach.tier === 'gold') goldAchievements.push(ach);
            if (ach.id === 'platinum_trophy') platinumData = ach;
        });
        goldAchievements.sort((a, b)=>a.name.localeCompare(b.name));
        const unlockedForPercentage = unlockedCount - countsByTier.platinum;
        const percentage = totalForPercentage > 0 ? Math.round(unlockedForPercentage / totalForPercentage * 100) : 0;
        let shareText = `\u{1F3C6} I Miei Trofei PAC-Maldini!

\u{1F9EE} ${percentage}% (${unlockedForPercentage}/${totalForPercentage})

\u{1F3C6} ${countsByTier.platinum}
\u{1F947} ${countsByTier.gold}
\u{1F948} ${countsByTier.silver}
\u{1F949} ${countsByTier.bronze}

\u{1F51D}
`;
        if (platinumData) shareText += `${unlockedAchievements[platinumData.id] ? "\u2705" : "\u274C"} ${platinumData.name}\n`;
        const fireEmoji = "\uD83D\uDD25";
        goldAchievements.forEach((ach)=>{
            const shouldAppendFire = ach.name.includes('Fire') && !ach.name.includes(fireEmoji);
            shareText += `${unlockedAchievements[ach.id] ? "\u2705" : "\u274C"} ${ach.name}${shouldAppendFire ? ` ${fireEmoji}` : ''}\n`;
        });
        shareText += `\nGioca anche tu: https://pac-maldini.web.app/`;
        shareText = shareText.trim();
        const encodedText = encodeURIComponent(shareText);
        const twitterUrl = `https://twitter.com/intent/tweet?text=${encodedText}`;
        return {
            copy: shareText,
            twitter: twitterUrl
        };
    }
    function handleShareTrophiesXClick() {
        const userData = profileManagerInstance?.getUserData();
        const allDefinitions = achievementManagerInstance?.getDefinitions();
        if (!userData || !allDefinitions) {
            alert("Errore recupero dati condivisione.");
            return;
        }
        const messages = generateTrophyShareMessages(userData, allDefinitions);
        if (messages?.twitter) window.open(messages.twitter, '_blank');
        else alert("Errore preparazione messaggio X.");
    }
    function handleCopyTrophiesClick() {
        const userData = profileManagerInstance?.getUserData();
        const allDefinitions = achievementManagerInstance?.getDefinitions();
        if (!userData || !allDefinitions) {
            alert("Errore recupero dati copia.");
            return;
        }
        const messages = generateTrophyShareMessages(userData, allDefinitions);
        if (!messages?.copy) {
            alert("Errore preparazione testo da copiare.");
            return;
        }
        if (!copyTrophiesButton) {
            console.error("Pulsante copia trofei non trovato!");
            alert("Errore interno.");
            return;
        }
        if (navigator.clipboard?.writeText) navigator.clipboard.writeText(messages.copy).then(()=>showCopiedFeedback(copyTrophiesButton, 'trophies')).catch(()=>alert("Impossibile copiare."));
        else try {
            const ta = document.createElement("textarea");
            ta.value = messages.copy;
            ta.style.position = "fixed";
            ta.style.left = "-9999px";
            document.body.appendChild(ta);
            ta.focus();
            ta.select();
            document.execCommand('copy');
            document.body.removeChild(ta);
            showCopiedFeedback(copyTrophiesButton, 'trophies');
        } catch (err) {
            alert("Copia automatica fallita.");
        }
    }
    return {
        initialize: initialize
    };
}(); // Chiusura IIFE
 // --- END OF FILE public/js/landingpage/js/profile-ui.js ---


// --- START OF FILE public/landingpage/js/video.js ---
/**
 * Contiene l'URL dell'ultima live/video da mostrare nella sezione "Entra nel Manicomio"
 * e il tempo di inizio desiderato.
 * AGGIORNA MANUALMENTE QUESTI VALORI QUANDO NECESSARIO.
 */ window.latestVideoData = {
    // Incolla qui l'URL completo di condivisione da YouTube (es. https://youtu.be/xxxxxx o https://www.youtube.com/watch?v=xxxxxx)
    url: "https://youtu.be/nNv5xly1vhQ?si=VzfD7ktxakyjopTN",
    // Specifica il tempo di inizio in secondi (0 per iniziare dall'inizio)
    startTimeSeconds: 170 // <-- IMPOSTA QUI I SECONDI
}; // --- END OF FILE public/landingpage/js/video.js ---


// --- START OF FILE public/landingpage/js/main.js ---
/**
 * landingpage/js/main.js v1.18 - FIX: Initialize Auth Event Listeners
 * Funzionalità principali della landing page.
 * FIX: Aggiunta la chiamata a `authManager.initEventListeners()` dopo
 *      l'istanziazione di AuthManager. Questo attiva la logica per il toggle
 *      della password (occhietto), che prima non veniva inizializzata.
 * MANTIENE: Logica di inizializzazione e UI centralizzata.
 */ function $e110d925623b4442$var$initializeGlobalManagers() {
    console.log("[Global Managers - Landing] Inizializzazione (v1.18)...");
    if (!window.firebaseServices || !window.firebaseServices.auth || !window.firebaseServices.db) {
        console.error("[Global Managers - Landing Critical Error] Servizi Firebase (auth/db) NON DISPONIBILI.");
        return false;
    }
    try {
        if (!window.authManager) {
            window.authManager = new AuthManager();
            console.log("[GM Landing] AuthManager istanziato.");
            // --- FIX: Chiamata al metodo mancante ---
            if (typeof window.authManager.initEventListeners === 'function') {
                window.authManager.initEventListeners();
                console.log("[GM Landing] AuthManager event listeners (password toggle) inizializzati.");
            }
        // --- FINE FIX ---
        }
        if (!window.profileManager) {
            window.profileManager = new ProfileManager();
            console.log("[GM Landing] ProfileManager istanziato.");
        }
        if (!window.leaderboardManager) {
            window.leaderboardManager = new LeaderboardManager();
            console.log("[GM Landing] LeaderboardManager istanziato.");
        }
        if (!window.achievementManager && window.profileManager) {
            const dE = {
                on: ()=>{},
                off: ()=>{}
            };
            const dG = {
                scene: {},
                events: dE,
                time: {
                    delayedCall: (d, c, a, s)=>setTimeout(()=>c.apply(s, a), d)
                }
            };
            window.achievementManager = new AchievementManager(window.profileManager, dG);
            console.log("[GM Landing] AchievementManager istanziato.");
        } else if (!window.profileManager && !window.achievementManager) console.warn("[GM Landing] ProfileManager mancante per AchievementManager.");
        if (!window.audioManager && typeof AudioManager !== 'undefined' && typeof Howl !== 'undefined') {
            window.audioManager = new AudioManager();
            console.log("[GM Landing] AudioManager istanziato.");
        } else if (typeof AudioManager === 'undefined' || typeof Howl === 'undefined') console.warn("[GM Landing] AudioManager/Howler non definiti.");
        if (window.leaderboardManager) {
            if (window.authManager && !window.leaderboardManager.authManager) window.leaderboardManager.authManager = window.authManager;
            if (window.profileManager && !window.leaderboardManager.profileManager) window.leaderboardManager.profileManager = window.profileManager;
        }
        console.log("[Global Managers - Landing] Inizializzazione manager completata con successo.");
        return true;
    } catch (e) {
        console.error("[Global Managers - Landing] ERRORE ISTANZIAZIONE MANAGER:", e.message, e.stack);
        return false;
    }
}
document.addEventListener('DOMContentLoaded', function() {
    console.log('[Landing Main v1.18] DOM caricato');
    document.fonts.load('10px Arcade').then(()=>console.log('[Landing Main] Font Arcade caricato.')).catch((err)=>console.warn("Errore font:", err));
    console.log('[Landing Main] Avvio waitForFirebase...');
    $e110d925623b4442$var$waitForFirebase();
    $e110d925623b4442$var$configureSafeAreas();
    document.removeEventListener('visibilitychange', $e110d925623b4442$var$handleVisibilityChange);
    document.addEventListener('visibilitychange', $e110d925623b4442$var$handleVisibilityChange);
});
function $e110d925623b4442$var$configureSafeAreas() {
    const safeAreaInsets = $e110d925623b4442$var$getSafeAreaInsets();
    if (safeAreaInsets.top > 0 || safeAreaInsets.left > 0 || safeAreaInsets.right > 0 || safeAreaInsets.bottom > 0) {
        console.log('[Landing Main] Rilevate safe areas:', safeAreaInsets);
        const bodyPaddingLeft = parseInt(window.getComputedStyle(document.body).paddingLeft) || 0;
        const bodyPaddingRight = parseInt(window.getComputedStyle(document.body).paddingRight) || 0;
        document.body.style.paddingLeft = `max(${safeAreaInsets.left}px, ${bodyPaddingLeft}px)`;
        document.body.style.paddingRight = `max(${safeAreaInsets.right}px, ${bodyPaddingRight}px)`;
    }
}
function $e110d925623b4442$var$getSafeAreaInsets() {
    const temp = document.createElement('div');
    temp.style.paddingLeft = 'env(safe-area-inset-left)';
    temp.style.paddingRight = 'env(safe-area-inset-right)';
    temp.style.paddingTop = 'env(safe-area-inset-top)';
    temp.style.paddingBottom = 'env(safe-area-inset-bottom)';
    temp.style.position = 'absolute';
    temp.style.left = '-9999px';
    document.body.appendChild(temp);
    const style = window.getComputedStyle(temp);
    const insets = {
        left: parseInt(style.paddingLeft) || 0,
        right: parseInt(style.paddingRight) || 0,
        top: parseInt(style.paddingTop) || 0,
        bottom: parseInt(style.paddingBottom) || 0
    };
    try {
        document.body.removeChild(temp);
    } catch (e) {}
    return insets;
}
async function $e110d925623b4442$var$waitForFirebase(attempts = 0) {
    const MAX_ATTEMPTS = 15;
    const WAIT_TIME = 350;
    if (window.firebaseServices && typeof window.firebaseServices.auth !== 'undefined' && typeof window.firebaseServices.db !== 'undefined') {
        console.log('[Landing Main waitForFirebase v1.18] Servizi Firebase base pronti.');
        if (window.firebaseServices.persistenceSetupPromise && typeof window.firebaseServices.persistenceSetupPromise.then === 'function') {
            console.log('[Landing Main waitForFirebase v1.18] Attendo persistenceSetupPromise...');
            try {
                await window.firebaseServices.persistenceSetupPromise;
                console.log('[Landing Main waitForFirebase v1.18] persistenceSetupPromise RISOLTA.');
            } catch (e) {
                console.error('[Landing Main waitForFirebase v1.18] Errore imprevisto attendendo persistenceSetupPromise:', e);
            }
        } else console.warn('[Landing Main waitForFirebase v1.18] persistenceSetupPromise non trovata!');
        if ($e110d925623b4442$var$initializeGlobalManagers()) {
            console.log('[Landing Main waitForFirebase v1.18] Manager globali inizializzati. Avvio UI asincrona...');
            $e110d925623b4442$var$initializeLandingPageAsync();
        } else {
            console.error("[Landing Main waitForFirebase v1.18] FALLIMENTO inizializzazione manager globali! UI di base.");
            $e110d925623b4442$var$initializeBasicUI();
        }
        return;
    }
    attempts++;
    if (attempts > MAX_ATTEMPTS) {
        console.error(`[Landing Main v1.18] Servizi Firebase non disponibili dopo ${MAX_ATTEMPTS} tentativi. UI di base.`);
        $e110d925623b4442$var$initializeBasicUI();
        return;
    }
    console.log(`[Landing Main waitForFirebase v1.18] Attesa Servizi Firebase (${attempts}/${MAX_ATTEMPTS})...`);
    setTimeout(()=>$e110d925623b4442$var$waitForFirebase(attempts), WAIT_TIME);
}
function $e110d925623b4442$var$initializeBasicUI() {
    console.warn('[Landing Main] Init Basic UI (Firebase/Managers non pronti)');
    const loading = document.getElementById('loading');
    if (loading) loading.style.display = 'none';
    $e110d925623b4442$var$setupGameButtons();
    const lbBody = document.getElementById('leaderboard-body');
    if (lbBody) lbBody.innerHTML = '<tr><td colspan="3" style="text-align: center; padding: 20px; color: #FFAAAA;">Classifica non disponibile</td></tr>';
    const lbArrow = document.getElementById('leaderboard-arrow');
    if (lbArrow) lbArrow.classList.remove('visible');
    const lbButton = document.getElementById('leaderboard-button');
    if (lbButton) lbButton.disabled = true;
    $e110d925623b4442$var$setLiveVideoSource();
    if (typeof window.updateGlobalUserUI === 'function') window.updateGlobalUserUI(null);
}
function $e110d925623b4442$var$extractYouTubeVideoId(url) {
    if (!url) return null;
    let videoId = null;
    try {
        const urlObj = new URL(url);
        if (urlObj.hostname === 'youtu.be') videoId = urlObj.pathname.substring(1);
        else if (urlObj.hostname.includes('youtube.com') && urlObj.pathname === '/watch') videoId = urlObj.searchParams.get('v');
        else if (urlObj.hostname.includes('youtube.com') && urlObj.pathname.startsWith('/embed/')) videoId = urlObj.pathname.split('/')[2];
        if (videoId) {
            const queryIndex = videoId.indexOf('?');
            if (queryIndex > -1) videoId = videoId.substring(0, queryIndex);
        }
    } catch (e) {
        const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
        const match = url.match(regex);
        if (match && match[1]) videoId = match[1];
    }
    return videoId;
}
function $e110d925623b4442$var$setLiveVideoSource() {
    const iframe = document.getElementById('live-video-iframe');
    const videoContainer = iframe?.closest('.video-visual');
    if (!iframe) {
        if (videoContainer) videoContainer.style.display = 'none';
        return;
    }
    if (window.latestVideoData && window.latestVideoData.url) {
        const sourceUrl = window.latestVideoData.url;
        const startTime = window.latestVideoData.startTimeSeconds || 0;
        const videoId = $e110d925623b4442$var$extractYouTubeVideoId(sourceUrl);
        if (videoId) {
            const embedUrl = `https://www.youtube.com/embed/${videoId}?rel=0&showinfo=0&controls=0&start=${startTime}`;
            iframe.src = embedUrl;
            if (videoContainer) videoContainer.style.display = 'block';
        } else if (videoContainer) videoContainer.style.display = 'none';
        else iframe.style.display = 'none';
    } else {
        if (videoContainer) videoContainer.style.display = 'none';
        else if (iframe) iframe.style.display = 'none';
    }
}
async function $e110d925623b4442$var$initializeLandingPageAsync() {
    console.log('[Landing Main v1.18] initializeLandingPageAsync START');
    const loading = document.getElementById('loading');
    function showLoading() {
        if (loading) loading.style.display = 'flex';
    }
    function hideLoading() {
        if (loading) loading.style.display = 'none';
    }
    showLoading();
    try {
        if (window.LandingPageAuthUI?.initialize) window.LandingPageAuthUI.initialize();
        else console.error("LandingPageAuthUI non trovato!");
        if (window.LandingPageLeaderboardUI?.initialize) window.LandingPageLeaderboardUI.initialize();
        else console.error("LandingPageLeaderboardUI non trovato!");
        if (window.LandingPageProfileUI?.initialize) {
            if (window.profileManager && window.achievementManager) window.LandingPageProfileUI.initialize(window.profileManager, window.achievementManager);
            else console.error("Errore: ProfileManager o AM non trovati per LandingPageProfileUI.initialize!");
        } else console.error("LandingPageProfileUI non trovato!");
        if (window.achievementManager?.initialize) window.achievementManager.initialize();
        else console.warn("[Landing Main] AM non trovato o non inizializzabile.");
        if (!window.authManager) throw new Error("AuthManager non disponibile post-init!");
        await window.authManager.waitForAuthReady();
        if (typeof window.updateGlobalUserUI === 'function') window.updateGlobalUserUI(window.authManager.currentUser);
        if (window.authManager.isAuthenticated() && window.profileManager) await window.profileManager.loadUserCache(window.authManager);
        if (window.LandingPageLeaderboardUI?.loadLeaderboard) window.LandingPageLeaderboardUI.loadLeaderboard('weekly');
        $e110d925623b4442$var$setLiveVideoSource();
        $e110d925623b4442$var$setupGameButtons();
        $e110d925623b4442$var$setupSocialLinkListeners();
        $e110d925623b4442$var$handleWindowResize();
        window.removeEventListener('resize', $e110d925623b4442$var$handleWindowResize);
        window.addEventListener('resize', $e110d925623b4442$var$handleWindowResize);
    } catch (error) {
        console.error("[Landing Main v1.18] ERRORE CRITICO init:", error);
        $e110d925623b4442$var$initializeBasicUI();
    } finally{
        hideLoading();
        console.log('[Landing Main v1.18] initializeLandingPageAsync END.');
    }
}
window.updateGlobalUserUI = function(user) {
    const authButtons = document.getElementById('auth-buttons');
    const userInfo = document.getElementById('user-info');
    const userNameEl = document.getElementById('user-name');
    const readyActionButton = document.getElementById('ready-action-button');
    const isAuthenticated = !!user;
    let finalDisplayName = 'Utente';
    if (isAuthenticated) {
        if (user.displayName) finalDisplayName = user.displayName;
        else if (window.authManager) {
            finalDisplayName = window.authManager.getUserDisplayName();
            if (finalDisplayName === 'PLAYER' || !finalDisplayName) finalDisplayName = 'Profilo';
        } else if (user.email) finalDisplayName = user.email.split('@')[0].toUpperCase();
        else finalDisplayName = 'Profilo';
    }
    if (authButtons && userInfo && userNameEl) {
        if (isAuthenticated) {
            authButtons.style.display = 'none';
            userInfo.style.display = 'flex';
            userNameEl.textContent = finalDisplayName;
            userNameEl.title = 'Visualizza Profilo';
            userNameEl.style.cursor = 'pointer';
            userNameEl.style.textDecoration = 'underline';
        } else {
            authButtons.style.display = 'flex';
            userInfo.style.display = 'none';
            userNameEl.textContent = 'Utente';
            userNameEl.title = '';
            userNameEl.style.cursor = 'default';
            userNameEl.style.textDecoration = 'none';
        }
    }
    if (readyActionButton) {
        const startGame = ()=>{
            if (isAuthenticated && window.authManager) {
                localStorage.setItem('playMode', 'authenticated');
                localStorage.setItem('userId', window.authManager.getUserId());
                localStorage.setItem('userDisplayName', finalDisplayName);
            } else localStorage.setItem('playMode', 'guest');
            localStorage.setItem('fromLanding', 'true');
            window.location.href = '/play';
        };
        const newButton = readyActionButton.cloneNode(true);
        readyActionButton.parentNode.replaceChild(newButton, readyActionButton);
        const currentButton = document.getElementById('ready-action-button');
        if (isAuthenticated) {
            currentButton.textContent = 'GIOCA ORA';
            currentButton.className = 'btn btn-primary';
            currentButton.addEventListener('click', startGame);
        } else {
            currentButton.textContent = 'ACCEDI PER SALVARE PROGRESSI';
            currentButton.className = 'btn btn-secondary';
            if (window.LandingPageAuthUI?.showLoginModal) currentButton.addEventListener('click', window.LandingPageAuthUI.showLoginModal);
            else currentButton.disabled = true;
        }
    }
};
function $e110d925623b4442$var$setupGameButtons() {
    function startGame() {
        if (window.authManager?.isAuthenticated()) {
            localStorage.setItem('playMode', 'authenticated');
            localStorage.setItem('userId', window.authManager.getUserId());
            localStorage.setItem('userDisplayName', window.authManager.getUserDisplayName());
        } else localStorage.setItem('playMode', 'guest');
        localStorage.setItem('fromLanding', 'true');
        window.location.href = '/play';
    }
    const playButtonIds = [
        'play-button',
        'play-button-bottom'
    ];
    playButtonIds.forEach((id)=>{
        const btn = document.getElementById(id);
        if (btn) {
            const newBtn = btn.cloneNode(true);
            btn.parentNode.replaceChild(newBtn, btn);
            newBtn.addEventListener('click', startGame);
        }
    });
}
function $e110d925623b4442$var$handleWindowResize() {
    $e110d925623b4442$var$configureSafeAreas();
    if (typeof setupModalOrientation === 'function') setupModalOrientation();
}
function $e110d925623b4442$var$handleVisibilityChange() {
    if (document.visibilityState === 'visible') {
        if (window.achievementManager && typeof window.achievementManager.processPendingLandingNotifications === 'function') window.achievementManager.processPendingLandingNotifications();
    }
}
function $e110d925623b4442$var$setupSocialLinkListeners() {
    const socialLinks = document.querySelectorAll('a.social-icon, a.btn-social');
    socialLinks.forEach((link)=>{
        const achievementId = link.dataset.achievementId;
        if (achievementId) {
            link.removeEventListener('click', $e110d925623b4442$var$handleSocialLinkClick);
            link.addEventListener('click', $e110d925623b4442$var$handleSocialLinkClick);
        }
    });
}
function $e110d925623b4442$var$handleSocialLinkClick(event) {
    const link = event.currentTarget;
    const achievementId = link.dataset.achievementId;
    if (!achievementId) return;
    const profileMgr = window.profileManager;
    const authMgr = window.authManager;
    const achievementMgr = window.achievementManager;
    if (!profileMgr || !authMgr || !achievementMgr) return;
    const isLoggedIn = authMgr.isAuthenticated();
    const achievements = profileMgr.getUserAchievements();
    const alreadyUnlocked = isLoggedIn && achievements && achievements[achievementId];
    if (isLoggedIn && !alreadyUnlocked) achievementMgr.attemptUnlock(achievementId);
} // --- END OF FILE public/landingpage/js/main.js ---


console.log("[Index Landing] Inizio caricamento moduli per la landing page (v1.1)...");
console.log("[Index Landing] Tutti i moduli per la landing page importati e pronti (v1.1)."); // --- END OF FILE public/landingpage/js/index-landing.js ---


//# sourceMappingURL=public.70f5936b.js.map
